import Vue from 'vue'
import api from '../../api/api'
import format from '../../libs/format'

const log = {
  state: {
    list: [],
    page: {}
  },

  mutations: {
    SET_LOG_LIST(state, data) {
      state.list = data.list
      state.page = {
        page:data.pageno,
        total:data.totalcount
      }
    }
  },

  actions: {
    async getLogList({ commit, rootState }) {
      let params = Object.assign({},rootState.route.query)
      if(params.date) {
        params.starttime = format.date(params.date[0],'date') || ''
        params.stoptime = format.date(params.date[1],'date') || ''
        delete params.date
      }
      let ret = await api.getLog(params)
      commit('SET_LOG_LIST', ret.data)
      console.log('系统日志', ret)
    }
  }

};

export default log


// WEBPACK FOOTER //
// ./src/store/modules/log.js